/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_SupersetInputs */

const en_us2_plan_superset = /** @type {(inputs: Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset`)
};

const pt_br2_plan_superset = /** @type {(inputs: Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset`)
};

const es_419_plan_superset = /** @type {(inputs: Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superserie`)
};

const pt_pt2_plan_superset = /** @type {(inputs: Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset`)
};

const fr_fr2_plan_superset = /** @type {(inputs: Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset`)
};

const de_de2_plan_superset = /** @type {(inputs: Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supersatz`)
};

const it_it2_plan_superset = /** @type {(inputs: Plan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superset`)
};

/**
* | output |
* | --- |
* | "Superset" |
*
* @param {Plan_SupersetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_superset = /** @type {((inputs?: Plan_SupersetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_SupersetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_superset(inputs)
	if (locale === "es-419") return es_419_plan_superset(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_superset(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_superset(inputs)
	if (locale === "de-DE") return de_de2_plan_superset(inputs)
	if (locale === "it-IT") return it_it2_plan_superset(inputs)
	return en_us2_plan_superset(inputs)
});
export { plan_superset as "plan.superset" }